import {ButtonGroupInputField} from 'components/system/fields/RadioButtonInputField'
import {SelectOption} from 'types/basic'

type Props = {
  bookingUuid: string
  unitItemId: string
  questionId: string
  options: SelectOption[]
}

export const ButtonGroupInput = ({bookingUuid, unitItemId, questionId, options}: Props) => {
  return <ButtonGroupInputField name={`[${bookingUuid}][${unitItemId}][${questionId}]`} options={options} />
}
